export enum messageTypes  {
    LOADING = 'LOADING',
    //@TODO ADD MESSAGE TYPES LATER
}


// WEBPACK FOOTER //
// ./src/app/helpers/MessageTypes.ts